// extracted by mini-css-extract-plugin
export var speaker = "speaker-module--speaker--2ab43";
export var speaker__container = "speaker-module--speaker__container--b7add";
export var speaker__img = "speaker-module--speaker__img--5c7b3";
export var speaker__info = "speaker-module--speaker__info--2e3d2";
export var speaker__item = "speaker-module--speaker__item--ef3a6";
export var speaker__itemIcon = "speaker-module--speaker__item-icon--614fb";
export var speaker__list = "speaker-module--speaker__list--0256c";
export var speaker__name = "speaker-module--speaker__name--d6668";
export var speaker__prof = "speaker-module--speaker__prof--ffd9f";